<style></style>
<template>
  <div class="creatCustomer-box">
    <div class="shade-box">
      <div class="shade-content">
        <p class="dialog-title-bg">{{title}}客户信息
          <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="resetUserForm('creatUserForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="creatForm" :rules="$rules" ref="creatUserForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="creatForm.userName" placeholder="请输入用户名" ref="userNameInput" clearable :disabled = isRevise></el-input>
            </el-form-item>
            <el-form-item label="电话号码" prop="userPhone">
              <el-input v-model="creatForm.userPhone" placeholder="请输入客户电话号码" clearable></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="userPassword" v-if="!isRevise">
              <el-input v-model="creatForm.userPassword" placeholder="请输入客户登录密码" @keyup.enter.native="submitForm('creatUserForm')"></el-input>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('creatUserForm')" :disabled="disabled">立即{{title}}</el-button>
              <el-button @click="resetUserForm('creatUserForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
import { Message } from 'element-ui'
export default {
  props: {
    data:{
      type: Object
    }
  },
  name: "creatCustomer",
  data(){
    return{
      title: '创建',
      disabled: false,
      isRevise: false,//是否是修改
      creatForm: {
        userName: '',
        userPhone: '',
        userPassword: ''
      },
    };
  },
  created(){
    if(this.data){
      this.creatForm = this.data;
      this.title = '修改';
      this.isRevise = true;
    }else{
      this.$nextTick(function(){
        this.$refs.userNameInput.focus();
      })
    }
  },
  methods: {
    submitForm(formName){//创建
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          if(this.isRevise){
            let data = {
              "userName": this.creatForm.userName,
              "userPhone": this.creatForm.userPhone
            }
            api.updateUser({data:data}).then(res =>{
              if(res.status == 'success'){
                Message.success(res.msg);
                this.$emit('componentClose');
              }else{
                this.disabled = false
              }
            })
          }else{
            let data = {
              "newUserName": this.creatForm.userName,
              "userPassword": this.$md5(this.$md5(this.creatForm.userPassword)),
              "userPhone": this.creatForm.userPhone
            }
            api.addUser({data:data}).then(res =>{
              if(res.status == "success"){
                Message.success(res.msg);
                this.$emit('componentClose');
              }else{
                this.disabled = false
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    resetUserForm(formName){//取消
      this.$refs[formName].resetFields();
      this.$emit('componentClose');
    }
  },
  components: {
    
  }
}
</script>
  




// WEBPACK FOOTER //
// src/components/customer/creatCustomer.vue